export default __webpack_public_path__ + "static/media/Raised.1df024ed.png";